const generateRandomString = (length: number): string => {
    const possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~"
    let text = ""
    for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    return text
}

const base64URLEncode = (str: ArrayBuffer): string => {
    return btoa(String.fromCharCode(...new Uint8Array(str)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "")
}

export const generatePKCE = async (): Promise<{
    codeVerifier: string
    codeChallenge: string
}> => {
    const codeVerifier = generateRandomString(128)
    const encoder = new TextEncoder()
    const data = encoder.encode(codeVerifier)
    const digest = await window.crypto.subtle.digest("SHA-256", data)
    const codeChallenge = base64URLEncode(digest)

    return {
        codeVerifier,
        codeChallenge,
    }
}

export const getStoredPKCE = (): {
    codeVerifier: string
    codeChallenge: string
} | null => {
    const stored = localStorage.getItem("pkce")
    return stored ? JSON.parse(stored) : null
}

export const storePKCE = (pkce: {
    codeVerifier: string
    codeChallenge: string
}): void => {
    localStorage.setItem("pkce", JSON.stringify(pkce))
}
